import { render, staticRenderFns } from "./orderIncome.vue?vue&type=template&id=84bb941a&scoped=true"
import script from "./orderIncome.vue?vue&type=script&lang=js"
export * from "./orderIncome.vue?vue&type=script&lang=js"
import style0 from "./orderIncome.vue?vue&type=style&index=0&id=84bb941a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bb941a",
  null
  
)

export default component.exports